import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const ConcurrentLoginPopup = ({ open, onClose, onConfirm, isLoading = false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon sx={{ color: "#ff9800", fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
            Concurrent Login Detected
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: "#666",
            "&:hover": { backgroundColor: "#f5f5f5" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2, color: "#555", lineHeight: 1.6 }}>
          We detected that you are already logged in on another browser or device.
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 2, color: "#555", lineHeight: 1.6 }}>
          If you continue with this login, your other session will be automatically terminated.
        </Typography>

        <Box
          sx={{
            backgroundColor: "#fff3e0",
            border: "1px solid #ffb74d",
            borderRadius: "8px",
            p: 2,
            mt: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: "#e65100", fontWeight: 500 }}>
            ⚠️ Note: This action cannot be undone. Make sure to save any unsaved work in your other session.
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            p: 2,
            mt: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: "#666", fontSize: "13px" }}>
            <strong>What happens next?</strong>
            <br />
            • Your other session will be immediately terminated
            <br />
            • You'll be logged in on this device
            <br />
            • Any unsaved work in the other session will be lost
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#ccc",
            color: "#666",
            "&:hover": {
              borderColor: "#999",
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          sx={{
            backgroundColor: "#0094FB",
            color: "white",
            "&:hover": {
              backgroundColor: "#0077CC",
            },
            px: 3,
          }}
        >
          {isLoading ? "Processing..." : "Continue Login"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConcurrentLoginPopup; 